module.exports = __webpack_public_path__ + "img/filter.f372dd3a.svg";